export interface AgentChatInterface {
  url: string;
}

export const SIDE_SIZE_OF_CHAT_BUBBLE = 61;
